import { type LucideIcon } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from 'src/lib/utils';

export type IInfoCardStat = {
  label: string;
  value: number;
  className?: string;
};

type Props = React.PropsWithChildren<{
  icon: LucideIcon;
  title: string;
  totalCount: number;
  stats: IInfoCardStat[];
}>;

const InfoCard = ({ icon: Icon, title, totalCount, stats, children }: Props) => (
  <Card>
    <CardHeader className="gap-3.5 space-y-0 p-5 pb-3.5">
      <div className="flex items-center gap-1.5">
        <div className="size-8 flex items-center justify-center bg-[color-mix(in_srgb,var(--accent-software-escrow,var(--color-mint))_8%,transparent)] shadow-[inset_0_0_0_1px_color-mix(in_srgb,var(--accent-software-escrow,var(--color-mint))_16%,transparent)] rounded-lg">
          <Icon className="size-4.5 shrink-0 text-accent-software-escrow" />
        </div>
        <CardTitle>{title}</CardTitle>
      </div>
      <div className="flex items-center min-h-11.25">
        <div className="flex items-end gap-0.5">
          <strong className="text-2xl font-extrabold text-foreground leading-none">{totalCount}</strong>
          <span className="text-sm font-semibold text-muted-foreground leading-none">apps</span>
        </div>
      </div>
    </CardHeader>
    <CardContent className="space-y-3.5 p-5 pt-0">
      <dl className="flex gap-5">
        {stats.map(({ label, value, className }) => (
          <div key={label} className={cn('space-y-1 font-bold', className)}>
            <dt className="text-2xs uppercase text-muted-foreground tracking-wider">{label}</dt>
            <dd className="text-sm leading-none text-foreground">{value}</dd>
          </div>
        ))}
      </dl>
      {children}
    </CardContent>
  </Card>
);

export default InfoCard;
